import BoxDrawer from 'components/BoxDrawer';
import { GridEx } from 'components/MuiExtras/Grid/GridEx';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import { GenericListItemDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { SelectTopics } from 'views/Topic/Components/SelectTopics';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    canSave: boolean;
    topic: GenericListItemDto;
    newListOpened: boolean;
}

interface IProps {
    name?: string;
    onSelect: (item: GenericListItemDto) => boolean;
    onClose: () => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class TopicSelectionDrawer extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            canSave: false,
            topic: null,
            newListOpened: false
        };
    }

    private returnSelection(item: GenericListItemDto) {
        const { onClose, onSelect } = this.props;

        if (onSelect(item)) {
            // Continua editando
            this.setState({
                canSave: false,
                topic: null,
                newListOpened: false
            });
        }
        else {
            onClose();
        }
    }

    public render() {
        const { name, onClose } = this.props;
        const { newListOpened } = this.state;
        return (
            <BoxDrawer
                open
                onClose={() => onClose()}
                title={name || this.props.t("Views.Topic.Dialogs.TopicSelectionDrawer.Title")}
            >
                <MuiPaper dense fullHeight elevation={0}>

                    <GridEx container direction="column" fullHeight wrap="nowrap">
                        <GridEx item overflow={this.state.topic ? null : "auto"} >
                            {
                                !newListOpened &&
                                <SelectTopics
                                    autoFocus
                                    onSelect={
                                        (item) => {
                                            this.returnSelection(item);
                                        }
                                    }
                                />
                            }
                        </GridEx>
                    </GridEx>

                </MuiPaper>
            </BoxDrawer>
        );
    }
}

export default withTranslation()(TopicSelectionDrawer);